import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../OnePage/scss/benefits.scss";

const benefitsData = [
  {
    title: "Impulsa tus ideas con respaldo real",
    subtitle: "Acompañamos a tu empresa desde el día 1",
    description:
      "Te ayudamos a ordenar y profesionalizar tu negocio desde el primer día. Contamos con un equipo especializado en contabilidad, finanzas y gestión. Entregamos reportes claros, asesoría constante y respaldo real.",
    image: require("../../../assets/images/landing/benefits/teamwork1.jpg"),
  },
  {
    title: "Respaldo real para tus decisiones",
    subtitle: "Nos importa tu negocio tanto como a ti",
    description:
      "Simplificamos procesos, respondemos ante fiscalizaciones y dudas, y reducimos tu carga operativa con una mirada estratégica y cercana.",
    image: require("../../../assets/images/landing/benefits/teamwork2.jpg"),
  },
  {
    title: "Tu equipo de confianza",
    subtitle: "Equipo experto, cercano y eficiente",
    description:
      "En BackApp Chile encontrarás el apoyo que necesitas para tomar decisiones más informadas, crecer de forma ordenada y enfocarte en lo importante.",
    image: require("../../../assets/images/landing/benefits/teamwork3.jpg"),
  },
];

export default function Benefits() {
  return (
    <section id="benefits">
      <div className="benefits-section">
        <h2 className="benefits-title">
          ¿Por qué elegir <span>BackApp</span> Chile?
        </h2>
        <div className="benefits-carousel">
          <Swiper
            modules={[Autoplay, Pagination]}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 1500, disableOnInteraction: false }}
            pagination={{ clickable: true }}
          >
            {benefitsData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="benefit-card-wrapper">
                  <div className="benefit-card">
                    <div className="benefit-text">
                      <h3>
                        {item.title.includes("BackApp") ? (
                          <>
                            {item.title.split("BackApp")[0]}
                            <span>BackApp</span>
                            {item.title.split("BackApp")[1]}
                          </>
                        ) : (
                          item.title
                        )}
                      </h3>
                      <h4>{item.subtitle}</h4>
                      <p>{item.description}</p>
                      <a href="#services" className="btn-benefit">
                        Nuestros servicios
                      </a>
                    </div>
                    <div className="benefit-image">
                      <img src={item.image} alt="beneficio" />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="custom-pagination" />
        </div>
      </div>
    </section>
  );
}
